<template>
  <layout-basic>
    <page-hero
      title="Compliance Training"
      lead="Know exactly who has completed mandatory training."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Stay audit-ready without the admin headache"
      :points="points"
      :columns="2"
      tint
    />

    <standard-cta
      title="Ready to simplify compliance?"
      lead="Watch the demo or experience IMPROVE and see how easy reporting can be."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionCompliance',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Compliance Training | IMPROVE',
      description:
        'Track mandatory training with confidence. Know exactly who has completed compliance learning.',
      path: '/solutions/compliance',
    });
  },
  data() {
    return {
      points: [
        'Clear visibility of completion status',
        'Reporting built for audits and managers',
        'Assign renewals before they expire',
        'Combine IMPROVE courses with your own policies',
        'Certificates included',
        'Simple enough for busy teams to run',
      ],
    };
  },
};
</script>
